import React from 'react';
import PageHero from '../../components/ui/PageHero';
import PageCTA from '../../components/ui/PageCTA';
import HomePricing from '../../components/home/HomePricing';

const Pricing = () => (
  <div>
    <PageHero
      label="Pricing Plans"
      title="Affordable"
      titleHighlight="Pricing"
      description="Simple, transparent INR packages — Starter, Business, and custom Enterprise builds."
      breadcrumb="Pricing"
    />
    <HomePricing showHeader={false} id="pricing-page" />
    <PageCTA
      title="Need a Custom Quote?"
      description="Tell us about your project and we'll send a tailored proposal within 24 hours."
      primaryLabel="Get Free Consultation"
      secondaryLabel="View Services"
      secondaryTo="/services"
    />
  </div>
);

export default Pricing;
